import { LinkNewTab } from './components/basic';
import {
  AMERICAN_ELDERBERRY_TILESET_NAME,
  AMERICAN_HAZELNUT_TILESET_NAME,
  BLACK_LOCUST_TILESET_NAME,
  BLACKCURRANT_TILESET_NAME,
  CHINESE_CHESTNUT_TILESET_NAME,
  HYBRID_POPLAR_TILESET_NAME,
} from '../../constants/tilesets';

export const LAND_BOUNDARIES_PREFIX = 'land-boundaries';
export const MAIN_SOURCE_ID = `${LAND_BOUNDARIES_PREFIX}-source`;
export const ZOOM_FOR_FALLBACK = 15;

export const FALLBACK_FEATURE_ID = 'fallback-feature';
export const FALLBACK_FEATURE_RADIUS = {
  value: 1000,
  units: 'meters',
}; // 1km radius -> ~750 acres

// (coords of demo bg image)
export const INIT_MAP_POSITION = {
  lat: 42.50625,
  lng: -76.5875,
  zoom: 15.5,
};

// Note: id is the tileset id, name is the crop name
export const TILESET_SPEC = [
  { name: CHINESE_CHESTNUT_TILESET_NAME, displayName: 'Chinese Chestnut' },
  { name: BLACK_LOCUST_TILESET_NAME, displayName: 'Black Locust' },
  { name: HYBRID_POPLAR_TILESET_NAME, displayName: 'Hybrid Poplar' },
  { name: BLACKCURRANT_TILESET_NAME, displayName: 'Blackcurrant' },
  {
    name: AMERICAN_ELDERBERRY_TILESET_NAME,
    displayName: 'American Elderberry',
  },
  { name: AMERICAN_HAZELNUT_TILESET_NAME, displayName: 'American Hazelnut' },
];

export const INIT_SELECTED_FEATURE_IDS_STATE = {}; // (stable object reference)

export const STEPS = {
  INPUT_ADDRESS: 'INPUT_ADDRESS',
  DRAW_MODE_PROMPT: 'DRAW_MODE_PROMPT',
  SELECT_REGIONS: 'SELECT_REGIONS',
  POST_SUBMIT: 'POST_SUBMIT',
};

export const SIDE_PANEL_WIDTHS = {
  md: '275px',
  lg: '360px',
};

export const SUITABILITY_INPUTS = [
  'pH',
  'Soil Texture',
  'Depth to RL',
  'Depth to WT',
  'Hydric Rate',
  'Drainage',
  'Flooding',
  'Steepness',
  'Heaving',
];

export const DRAWN_FEATURE_ID_PREFIX = 'drawn-feature-';

export const CROP_INFOS = {
  [CHINESE_CHESTNUT_TILESET_NAME]: {
    description: (
      <>
        <LinkNewTab href="https://www.propagateag.com/chinese-chestnut">
          Chinese chestnuts
        </LinkNewTab>{' '}
        are a perennial crop that helps farms diversify their crop production
        and improve overall profit per acre. These trees also help farms adapt
        to, and mitigate effects from extreme weather like drought and flooding.
        Today, U.S. production lags behind domestic demand, making for an
        enticing opportunity.
      </>
    ),
  },
  [BLACK_LOCUST_TILESET_NAME]: {
    description: (
      <>
        <LinkNewTab href="https://www.propagateag.com/black-locust">
          Black locust
        </LinkNewTab>{' '}
        is a fast-growing, high-value hardwood. The lumber is 30% stronger than
        white oak, and lasts for 30+ years in contact with the soil. Black
        locust lumber prices surpasses black walnut prices, and the tree reaches
        sawlog size in one-third of the time. Black locust is at the forefront
        of market-driven climate solutions in cold, humid climates.
        <br />
        <br />
        Reach out to learn about our exclusive license to the Turbo Obelisk
        variety group, a line of elite Robinia genetics with a straight growth
        form and exceptional growth rate.
      </>
    ),
  },
  [HYBRID_POPLAR_TILESET_NAME]: {
    description: (
      <>
        <LinkNewTab href="https://www.propagateag.com/blog/agroforestry-stormwater-management-and-flooding#:~:text=Second%2C-,Hybrid%20Poplar,-is%20an%20excellent">
          Hybrid Poplar
        </LinkNewTab>{' '}
        is an excellent fast-growing tree, tolerant of wet feet and saturated
        soils. The tree yields functional lumber after 20 year or fewer, but
        must be harvested before it senesces. Planting hybrid poplar is
        analogous to keeping money in treasury bonds or a savings account for 20
        years, rather than a portfolio of stocks. Trees such as black walnut and
        larch also yield modest returns over 40+ years.
      </>
    ),
  },
  [BLACKCURRANT_TILESET_NAME]: {
    description: (
      <>
        <LinkNewTab href="https://propagateventures.notion.site/Blackcurrant-20d63d604bb6487c8dd254927bb13014">
          Blackcurrants
        </LinkNewTab>{' '}
        are a popular commodity crop outside of the US, and coming into
        production domestically. With up to 5 lbs of yield per stem,
        blackcurrants can be sold wholesale as berries, fresh or frozen, or as
        juice. They are proving to be a productive and marketable crop with
        opportunities for cold-climate growers.
      </>
    ),
  },
  [AMERICAN_ELDERBERRY_TILESET_NAME]: {
    description: (
      <>
        Elderberries are a multi-use plant with a growing market in the US
        focused on the food-medicine qualities of the berries. Beyond the
        value-add market, they also have on-farm benefits in silvopasture
        systems. Learn more about Propagate&apos;s hen-silvopasture project with
        Handsome Brook Farms{' '}
        <LinkNewTab href="https://www.propagateag.com/case-study-hbf">
          here
        </LinkNewTab>
        .
      </>
    ),
  },
  [AMERICAN_HAZELNUT_TILESET_NAME]: {
    description: (
      <>
        Hazelnuts are a perennial crop that can yield decades of low-input nut
        production. While eastern fulbright blight has prevented
        commercialization of hazelnuts in the Eastern US, Propagate has worked
        with cultivars resistant to the fungal pathogen to set up working
        buffers on sub-prime and underutilized acreage in the Northeast.{' '}
        <LinkNewTab href="https://www.propagateag.com/working-buffer-case-study">
          Learn more
        </LinkNewTab>
        .
      </>
    ),
  },
};
